import axios from 'axios';

const api = '/api/agent-payed-netto-provision';

export const getLast2Years = agentId => {
  return axios.get(`${api}/last-2-years/${agentId}?cacheBuster=${new Date().getTime()}`);
};
